import { AnimalSpecies } from 'gql/types';

export const animalSpecies = Object.values(AnimalSpecies).map((value) => {
  return {
    value,
    label: value,
  };
});
